module.exports = __webpack_public_path__ + "static/img/icon_books.80031752.svg";